import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-notificacoes-perfis',
  templateUrl: './notificacoes-perfis.component.html',
  styleUrls: ['./notificacoes-perfis.component.scss']
})
export class NotificacoesPerfisComponent {

  @Input() notificacaoMensagens: string[] | [] = [];
  @Input() notificacaoStatus: string | 'alert-success' = 'alert-success';
  @Output() fecharNotificacoes = new EventEmitter<boolean>();



  ngAfterViewInit(){
    setTimeout(()=>{
      this.fecharNotificaoesAutomaticamente()
    }, 5000);
  }

  fecharNotificacao() {
    this.notificacaoMensagens = [];
  }

  fecharNotificaoesAutomaticamente(){
    this.notificacaoMensagens = [];
    this.fecharNotificacoes.emit(true);
  }

}
